import { render, staticRenderFns } from "./IndividualPlanDetails.vue?vue&type=template&id=5afb411c&scoped=true"
import script from "./IndividualPlanDetails.vue?vue&type=script&lang=ts"
export * from "./IndividualPlanDetails.vue?vue&type=script&lang=ts"
import style0 from "./IndividualPlanDetails.vue?vue&type=style&index=0&id=5afb411c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afb411c",
  null
  
)

export default component.exports